import { observer } from "mobx-react";
import {
  ContactsSegmentWrapper,
  Counter,
  SpreadsheetContactsMappingContainer,
} from "./ContactsSegment.styled";
import RulesView from "./components/RulesView";
import SegmentTable from "./components/SegmentTable";
import { useState, useEffect } from "react";
import {useStore} from "../../../../../../../hooks";
import SpreadsheetContactsMapping
  from "../../../../../BlastCampaigns/Tabs/SpreadsheetContactsMapping/SpreadsheetContactsMapping";


const ContactsSegment = observer(({onFileUpload, filters, showFile=false}) => {
  const { contactSegmentStore } = useStore();
  const [showContactMapping, setShowContactMapping] = useState(showFile);

  useEffect(() => {
      contactSegmentStore.getEventsCatalog();
  }, [])

  return (
    <>
      <Counter>
        <span>Contacts</span>
        {!showContactMapping && <span>{contactSegmentStore.totalRowCount}</span>}
      </Counter>
      <ContactsSegmentWrapper>
        {showContactMapping ? (
          <SpreadsheetContactsMappingContainer>
            <SpreadsheetContactsMapping showSendButton={true} onFileUpload={onFileUpload}/>
          </SpreadsheetContactsMappingContainer>
        ) : (
          <SegmentTable />
        )}
        <RulesView 
          showContactMapping={showContactMapping} 
          setShowContactMapping={setShowContactMapping}
          filters={filters}
        />
      </ContactsSegmentWrapper>
    </>
  );
});

export default ContactsSegment;
